import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/control-errors.module.css';

function ControlErrorsTypography({ className = null, ...props }: TypographyProps) {
    return <Typography className={classNames([styles.container, className])} {...props} />;
}

export default ControlErrorsTypography;
